
export const EMOTICON_TOKENS: readonly string[] = [
  "(황당)",
  "(돈)",
  "(기쁨)",
  "(좋아)",
  "(사랑)",
  "(분노)",
  "(아하)",
  "(우울)",
  "(죄송)",
  "(!)",
  "(?)",
  "(fish)",
];

export const EMOTICON_EFFECTS: readonly string[] = [
  "emoticon_sweat",
  "emoticon_money",
  "emoticon_happy",
  "emoticon_love_s",
  "emoticon_love_l",
  "emoticon_angry",
  "emoticon_aha",
  "emoticon_gloom",
  "emoticon_sorry",
  "emoticon_exclamation",
  "emoticon_question",
  "emoticon_fish",
];

export const EMOTICON_KEYED_COUNT = 9;

export const EMOTICON_REPEAT_MS = 1_000;

// sweat.mse:16 `CycleLength 1.500000` + sweat.mse:52-55 `TimeEventLifeTime`
// `0.000000 1.500000`;
// InstanceBaseEffect.cpp:965-970 is the test that reads the result.
export const EMOTICON_LIFETIME_MS = 3_000;

export function parseEmoticon(text: string): number | null {
  const index = EMOTICON_TOKENS.indexOf(text);
  return index === -1 ? null : index;
}

/** The token a key press sends, or null for an index no table row covers. */
export function emoticonToken(index: number): string | null {
  return EMOTICON_TOKENS[index] ?? null;
}

/** The manifest key an index draws with, or null for an index off the table. */
export function emoticonEffect(index: number): string | null {
  return EMOTICON_EFFECTS[index] ?? null;
}

/** One icon waiting to be drawn: whose head it goes over, and which file. */
export interface EmoticonPlay {
  readonly entityId: number;
  readonly effect: string;
}

export class Emoticons {
  private readonly lastMs = new Map<number, number>();
  private queue: EmoticonPlay[] = [];

  play(entityId: number, index: number, nowMs: number): boolean {
    const effect = emoticonEffect(index);
    if (effect === null) return false;
    const last = this.lastMs.get(entityId);
    if (last !== undefined && nowMs - last < EMOTICON_LIFETIME_MS) return false;
    this.lastMs.set(entityId, nowMs);
    this.queue.push({ entityId, effect });
    return true;
  }

  register(entityId: number, text: string, nowMs: number): boolean {
    const index = parseEmoticon(text);
    if (index === null) return false;
    this.play(entityId, index, nowMs);
    return true;
  }

  /** The icons owed a draw, emptying the queue. */
  drain(): readonly EmoticonPlay[] {
    if (this.queue.length === 0) return EMPTY;
    const out = this.queue;
    this.queue = [];
    return out;
  }

  /** A new world -- `CPythonCharacterManager::Destroy`'s moment, the same one
   *  `chatTails.clear()` answers. */
  clear(): void {
    this.lastMs.clear();
    this.queue = [];
  }
}

const EMPTY: readonly EmoticonPlay[] = [];

/** This tree's `CPythonCharacterManager::Instance()` for emoticons. */
export const emoticons = new Emoticons();
